export const Categories = [
  {
    name: "Autobiography",
    img: "./assets/icons/person.svg",
  },
  {
    name: "Adult",
    img: "./assets/icons/ps_gun.svg",
  },
  {
    name: "Adventure",
    img: "./assets/icons/adventure.svg",
  },
  {
    name: "Horror",
    img: "./assets/icons/bx_ghost.svg",
  },
  {
    name: "Mystery",
    img: "./assets/icons/mystery.svg",
  },
  {
    name: "Romance",
    img: "./assets/icons/balloon.svg",
  },
  {
    name: "Literature",
    img: "./assets/icons/sci-fi.svg",
  },
  {
    name: "Thriller",
    img: "./assets/icons/thriller.svg",
  },
  {
    name: "Fantasy",
    img: "./assets/icons/adventure.svg",
  },
  {
    name: "Religion",
    img: "./assets/icons/scale.svg",
  },
  {
    name: "Manga",
    img: "./assets/icons/thriller.svg",
  },
  {
    name: "Motivational",
    img: "./assets/icons/question.svg",
  },
];
